import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../App";

const Stat = ({ label, value, sub }) => (
  <div className="bg-white border kt-line rounded-2xl p-5 kt-shadow" data-testid={`stat-${label.replace(/\s/g, "-").toLowerCase()}`}>
    <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66]">{label}</div>
    <div className="font-serif text-3xl text-[#383633] mt-1">{value}</div>
    {sub && <div className="text-[11px] text-[#A8AD94] mt-1">{sub}</div>}
  </div>
);

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/admin/dashboard`).then((r) => setD(r.data)); }, []);
  if (!d) return <div className="text-[#6F6B66]">…</div>;
  return (
    <div data-testid="admin-dashboard">
      <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-2">Overview</div>
      <h1 className="font-serif text-3xl text-[#383633] tracking-tight mb-8">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat label="Assessments completed" value={d.assessments_completed} />
        <Stat label="Emails collected" value={d.emails_collected} />
        <Stat label="€9.88 payments" value={d.payments_completed} sub={`Conversion ${d.conversion_rate}%`} />
        <Stat label="Complimentary unlocks" value={d.complimentary_unlocks} />
        <Stat label="Credit codes issued" value={d.codes_issued} />
        <Stat label="Credit codes redeemed" value={d.codes_redeemed} />
        <Stat label="Complimentary codes active" value={d.complimentary_codes_active} />
        <Stat label="Completion rate" value={`${d.completion_rate}%`} />
      </div>

      <div className="mt-8 grid md:grid-cols-2 gap-4">
        <div className="bg-white border kt-line rounded-2xl p-5">
          <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">By language</div>
          <ul className="text-sm text-[#383633] space-y-1">
            {Object.entries(d.by_language || {}).map(([k, v]) => (
              <li key={k} className="flex items-center justify-between">
                <span className="uppercase kt-tracking text-xs text-[#6F6B66]">{k}</span>
                <span className="font-mono">{v}</span>
              </li>
            ))}
            {!Object.keys(d.by_language || {}).length && <li className="text-[#6F6B66]">No assessments yet.</li>}
          </ul>
        </div>
        <div className="bg-white border kt-line rounded-2xl p-5">
          <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">Integrations</div>
          <ul className="text-sm text-[#383633] space-y-2">
            <li className="flex items-center justify-between">
              <span>Shopify</span>
              <span className={`text-xs kt-tracking uppercase ${d.shopify_connected ? "text-[#A8AD94]" : "text-[#6F6B66]"}`}>
                {d.shopify_connected ? "Connected" : "Not connected"}
              </span>
            </li>
            <li className="flex items-center justify-between">
              <span>Odoo</span>
              <span className={`text-xs kt-tracking uppercase ${d.odoo_connected ? "text-[#A8AD94]" : "text-[#6F6B66]"}`}>
                {d.odoo_connected ? "Connected" : "Not connected"}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
